import { render } from "./inventariorecepcion.vue?vue&type=template&id=3efb4882&scoped=true"
import script from "./inventariorecepcion.vue?vue&type=script&lang=js"
export * from "./inventariorecepcion.vue?vue&type=script&lang=js"

import "./inventariorecepcion.vue?vue&type=style&index=0&id=3efb4882&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3efb4882"]])

export default __exports__